export default __webpack_public_path__ + "static/media/DottedLineGraphicred.085b4d29.png";